<template>
  <div v-if="messages && messages.length">
    <h5 class="mt-0">
      Messages
    </h5>

    <div
      v-for="message in messages"
      :key="message.id"
      class="media-body mb-3"
      :class="message.private ? &quot;alert-warning&quot; : &quot;media-success&quot;"
    >
      <h5
        v-if="message.from"
        class="mt-0 mb-0"
      >
        {{ message.from }}
        <!-- {{ message.sender_name.firstname }} {{ message.sender.lastname }} -->

        <span
          v-if="message.private"
          class="float-right"
        >
          Message interne
        </span>
      </h5>

      <div class="mb-1 text-dark">
        <small>{{ message.created_at }}</small>
      </div>
      <div class="text-dark messageBody">
        <p>{{ message.body }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Tls from "@/services/Tls";

const data = () =>({
	messages: []
});

const fetchMessages = function () {
	const { caseId, groupId } = this;

	Tls.Messages.all({ caseId, groupId }).then(response => {
		if (response.messages) {
			this.messages = response.messages;
		}
	});
};

const refresh = fetchMessages;

export default {
	name: "MessagesList",
	props: {
		caseId: {
			type: String,
			required: true
		},
		groupId: {
			type: String,
			required: false,
			default: null,
		}
	},
	data,
	watch: {
		"caseId": "fetchMessages"
	},
	mounted() {
		this.fetchMessages();
	},
	methods: {
		refresh,
		fetchMessages
	}
};
</script>
